import React, { useEffect, useState } from 'react';

import { Button } from 'lighthouse';
import { Typography } from 'lighthouse';

import { useCountdownTimer } from '@/hooks/common/useCounterDownTimer/useCounterDownTimer';

import { timerProps } from './models';

import { Refresh } from 'iconsax-react';

const Timer = ({ onResend }: timerProps) => {
    const { formattedTime, start, isFinished, reset } = useCountdownTimer(120);

    const [isResetButtonLoading, setIsResetButtonLoading] = useState(false);

    const handleResendCode = async () => {
        setIsResetButtonLoading(true);
        try {
            await onResend();
            reset();
            start();
        } catch (error: any) {
            if (error.response?.data?.error?.code === 'OTP.ALREADY_GENERATED') {
                reset();
                start();
            }
        } finally {
            setIsResetButtonLoading(false);
        }
    };

    useEffect(() => {
        start();
    }, []);

    return (
        <div className='mr-auto flex min-h-[36.5px] items-center'>
            {isFinished ? (
                <Button
                    color='primary'
                    onClick={handleResendCode}
                    loading={isResetButtonLoading}
                    endIcon={<Refresh color='currentcolor' size={16} />}>
                    دریافت مجدد کد
                </Button>
            ) : (
                <Typography variant='caption' className='inline-flex items-center gap-1'>
                    <span>زمان باقی‌مانده:</span>
                    <span className='font-mono inline-block w-[5ch] text-left tabular-nums' dir='ltr' style={{ fontVariantNumeric: 'tabular-nums' }}>
                        {formattedTime}
                    </span>
                </Typography>
            )}
        </div>
    );
};

export default Timer;
